import { render } from "./FourPeople.vue?vue&type=template&id=bc2540ee&scoped=true"
import script from "./FourPeople.vue?vue&type=script&lang=js"
export * from "./FourPeople.vue?vue&type=script&lang=js"

import "./FourPeople.vue?vue&type=style&index=0&id=bc2540ee&scoped=true&lang=css"

import exportComponent from "../../../../../app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc2540ee"]])

export default __exports__